import { ToolType } from '../store/stateSchema';
import { LocalStorageKeys } from './types';

export const getSessionsWithSelectedTool = (): Record<number, ToolType> => {
  const sessionsWithSelectedTool = localStorage.getItem(
    LocalStorageKeys.SESSIONS_WITH_SELECTED_TOOL
  );

  if (!sessionsWithSelectedTool) {
    return {};
  }

  return JSON.parse(sessionsWithSelectedTool);
};
